import React, { useEffect, useState } from 'react';
import { Button, Card, Modal, Spin, Tag, Typography, message } from 'antd';
import { useNavigate } from 'react-router-dom';

import { tradeAPI } from '../../services/api';

const { Title, Text } = Typography;

function Field({ label, value }) {
  const v = value === null || value === undefined || value === '' ? '-' : String(value);
  return (
    <div style={{ display: 'flex', gap: 10, marginTop: 6 }}>
      <div style={{ width: 70, color: '#666', flex: '0 0 auto' }}>{label}</div>
      <div style={{ color: '#111', flex: 1, wordBreak: 'break-all' }}>{v}</div>
    </div>
  );
}

export default function MobileMasterDataTopics() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);

  const handleToggleSync = (topic) => {
    const enabled = !!topic?.schedule_enabled;
    const title = enabled ? '确认停用同步' : '确认启用同步';
    const content = enabled ? `确定要停用话题 "${topic?.name || ''}" 的自动同步吗？` : `确定要启用话题 "${topic?.name || ''}" 的自动同步吗？`;

    Modal.confirm({
      title,
      content,
      okText: '确认',
      cancelText: '取消',
      onOk: async () => {
        try {
          await tradeAPI.updateTopicSchedule(topic.id, {
            enabled: !enabled,
            interval_minutes: topic.schedule_interval_minutes,
          });
          message.success(enabled ? '已停用自动同步' : '已启用自动同步');
          fetchList();
        } catch (error) {
          message.error(error?.response?.data?.detail || (enabled ? '停用自动同步失败' : '启用自动同步失败'));
        }
      },
    });
  };

  const fetchList = async () => {
    setLoading(true);
    try {
      const resp = await tradeAPI.getTopics();
      const data = resp?.data;
      setItems(Array.isArray(data) ? data : []);
    } catch (e) {
      message.error('获取列表失败');
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchList();
  }, []);

  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', background: '#f5f5f5' }}>
      <div
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 10,
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          padding: '16px 16px 12px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10 }}>
          <Title level={4} style={{ margin: 0, color: '#fff', fontWeight: 600 }}>
            交易话题
          </Title>
          <div style={{ display: 'flex', gap: 8 }}>
            <Button
              size="small"
              onClick={fetchList}
              disabled={loading}
              style={{
                background: 'rgba(255,255,255,0.2)',
                borderColor: 'rgba(255,255,255,0.3)',
                color: '#fff',
                backdropFilter: 'blur(10px)',
              }}
            >
              刷新
            </Button>
            <Button
              size="small"
              onClick={() => navigate('/master-data', { replace: true })}
              style={{
                background: 'rgba(255,255,255,0.2)',
                borderColor: 'rgba(255,255,255,0.3)',
                color: '#fff',
                backdropFilter: 'blur(10px)',
              }}
            >
              返回
            </Button>
          </div>
        </div>
      </div>

      <div style={{ flex: 1, overflow: 'auto', padding: '20px 16px 16px' }}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: 50 }}>
            <Spin />
          </div>
        ) : (
          <div>
            {(items || []).map((row, idx) => (
              <Card key={row?.id ?? idx} style={{ borderRadius: 10, marginBottom: 12 }} styles={{ body: { padding: 12 } }}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    gap: 10,
                  }}
                >
                  <div style={{ fontWeight: 700, color: '#1677ff' }}>{row?.name || `记录 ${idx + 1}`}</div>
                  <Button size="small" type={row?.schedule_enabled ? 'primary' : 'default'} danger={!!row?.schedule_enabled} onClick={() => handleToggleSync(row)}>
                    {row?.schedule_enabled ? '停用同步' : '启用同步'}
                  </Button>
                </div>
                <Field label="名称" value={row?.name} />
                <Field label="市场" value={row?.market_type} />
                <Field label="外部ID" value={row?.external_topic_id} />
                <Field label="同步间隔" value={row?.schedule_interval_minutes ? `${row.schedule_interval_minutes}分钟` : '-'} />
                <div style={{ marginTop: 6 }}>
                  <Tag
                    style={{
                      height: 30,
                      width: 80,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                    color={row?.schedule_enabled ? 'green' : 'default'}
                  >
                    {row?.schedule_enabled ? '自动同步' : '未同步'}
                  </Tag>
                </div>
              </Card>
            ))}
            {!items || items.length === 0 ? (
              <Card style={{ borderRadius: 10 }} styles={{ body: { padding: 12 } }}>
                <Text type="secondary">暂无数据</Text>
              </Card>
            ) : null}
          </div>
        )}
      </div>
    </div>
  );
}
